"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.event = event;
exports.identify = identify;
exports.initialize = initialize;
exports.pageview = pageview;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
const HUBSPOT_QUEUE = '_hsq';
const internalHubspot = window[HUBSPOT_QUEUE] = window[HUBSPOT_QUEUE] || [];
function _loadHubSpot(config) {
  const hubspot_url = `https://js.hs-scripts.com/${config.accountId}.js`;

  /* eslint-disable */
  (function (i, s, o, g) {
    var a = s.createElement(o),
      m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', hubspot_url);
  /* eslint-enable */
}

function initialize(config, userInfo) {
  _loadHubSpot(config);
  identify(userInfo);
}
function identify(userInfo) {
  internalHubspot.push(['identify', userInfo]);
}
function pageview(rawPath) {
  if (!rawPath) {
    /* eslint-disable no-console */
    console.warn("HubSpot pageview rawPath is false");
    /* eslint-enable no-console */
    return;
  }
  const path = (0, _trim.default)(rawPath).call(rawPath);
  if (path === '') {
    /* eslint-disable no-console */
    console.warn("HubSpot pageview trimmed path is false");
    /* eslint-enable no-console */
    return;
  }
  internalHubspot.push(['setPath', path]);
  internalHubspot.push(['trackPageView']);
}
function _event(eventId) {
  internalHubspot.push(['trackEvent', {
    id: eventId
  }]);
}
function event({
  category,
  action,
  label
}) {
  _event(`${category}-${action}-${label}`);
}
var _default = exports.default = {
  initialize,
  identify,
  pageview,
  event
};